import { useSite } from "@/lib/site";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import { AboutSection } from "@/components/About";
import Gallery from "@/components/Gallery";
import Features from "@/components/Features";
import Benefits from "@/components/Benefits";
import ForOwners from "@/components/ForOwners";
import HowItWorks from "@/components/HowItWorks";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function HomePage() {
  const { tc, screenshots } = useSite();

  if (!tc) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-forest-950">
        <div
          className="h-10 w-10 animate-spin rounded-full border-2 border-gold border-t-transparent"
          data-testid="page-loading-spinner"
        />
      </div>
    );
  }

  return (
    <div className="bg-cream font-body text-ink">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <AboutSection content={tc} />
        <Gallery content={tc} screenshots={screenshots} />
        <Features content={tc} />
        <Benefits content={tc} />
        <ForOwners content={tc} />
        <HowItWorks content={tc} />
        <Faq content={tc} />
        <Contact content={tc} />
      </main>
      <Footer />
    </div>
  );
}
